import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from './styles';
import { ModuloTypes } from '../../@types/entities/modulo.entity';
import Chevron from '../../assets/icons/chevron';

interface Props {
  onButtonClick: () => void;
}

export default function BackToTop({ onButtonClick }: Props) {
  return (
    <Button $modulo={1} $color={40} onClick={onButtonClick}>
      <Chevron />
    </Button>
  );
}
